import { Link } from "react-router";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import scrollPageTo from "../utils/scrollPageTo";
import * as styles from "./NavTopbarMobile.module.css";

export default function NavTopbarMobile({ iconToDisplay, setIcon }) {
  function handleLogoClick(e) {
    const mobileSidebar =
      e.currentTarget.parentElement.parentElement.querySelector("aside");
    if (![...mobileSidebar.classList].includes("hide-mobile-sidebar")) {
      const mobileMenuIcon =
        e.currentTarget.parentElement.querySelector(".mobile-menu-icon");
      mobileSidebar.classList.add("hide-mobile-sidebar");
      mobileMenuIcon.classList.add("show-menu-icon");
      setIcon(<AiOutlineMenu />);
    }
    scrollPageTo("root");
  }

  function handleMenuIconClick(e) {
    const mobileSidebar =
      e.currentTarget.parentElement.parentElement.querySelector("aside");
    mobileSidebar.classList.toggle("hide-mobile-sidebar");

    if ([...e.currentTarget.classList].includes("show-menu-icon")) {
      e.currentTarget.classList.remove("show-menu-icon");
      setIcon(<AiOutlineClose />);
    } else {
      e.currentTarget.classList.add("show-menu-icon");
      setIcon(<AiOutlineMenu />);
    }
  }

  return (
    <div className={`${styles.navTopbarMobile} mobile-nav-topbar`}>
      <span className={styles.logoContainer} onClick={handleLogoClick}>
        <Link to="/" className={styles.navLogo}>
          Oluwatobi
        </Link>
      </span>
      <span
        className={`${styles.menuIcon} mobile-menu-icon show-menu-icon`}
        onClick={handleMenuIconClick}
      >
        {iconToDisplay}
      </span>
    </div>
  );
}
